String.prototype.toUpperCaseChar = function(at = 0, start = 1) {
	return this.charAt(at).toUpperCase() + this.slice(start);
};
